/**
 * Route for `impact-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ImpactIntegrationViaApiPage } from "../features/impact-integration-via-api/ImpactIntegrationViaApiPage";

export const impactIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/impact-integration-via-api",
	component: ImpactIntegrationViaApiPage,
});

export default impactIntegrationViaApiRoute;
